import { COLORS } from 'apps/agora/src/v3/global';

interface SessionDetailsChatMessageProps {
  timestamp: string;
  accentColor: string;
  author: string;
  authenticatedUserFullName: string;
  message: string;
  startTime?: string;
}

const SessionDetailsChatMessage = (props: SessionDetailsChatMessageProps) => {
  const { timestamp, startTime, accentColor, author, authenticatedUserFullName, message } = props;
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        {timestamp && startTime ? (
          <p className="text-customGrey text-xs leading-4 font-light">{timestamp}</p>
        ) : (
          'n/a'
        )}
        <p
          className="text-black text-xs font-bold p-1 rounded-xsm"
          style={{
            backgroundColor:
              author !== authenticatedUserFullName ? accentColor : COLORS.TEXT_SECONDARY,
          }}
        >
          {author === authenticatedUserFullName ? 'You' : author}
        </p>
      </div>
      <p className="text-white text-sm leading-5 break-words">{message}</p>
    </div>
  );
};

export default SessionDetailsChatMessage;
